import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import PropTypes from 'prop-types'
import * as routes from 'core/routing/constants'

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props => {
      if (!localStorage.getItem('config')) return <Redirect to={routes.ERROR} />

      if (localStorage.getItem('isGlobalDealer')) return <Component {...props} />

      return <Redirect to={routes.TRADEIN} />
    }}
  />
)

PrivateRoute.propTypes = {
  component: PropTypes.func.isRequired
}

export default PrivateRoute
